const SvgWave = props => <svg viewBox="0 0 100 100" preserveAspectRatio="none" {...props}><path d="M100 100 H0 V100 H0 V50 C 33.3333 100, 66.6666 0, 100 50" /></svg>;
export default SvgWave;